interface ApiError {
  data?: {
    message?: string | string[];
    detail?: Array<{ msg: string | Array<{ msg: string }> }> | { msg?: string };
  };
  message?: string;
  error?: string;
}

// RTK Query errors are either an HTTP error with a status or a SerializedError without one.
export const isErrorStatus = (error: unknown, status: number): boolean =>
  typeof error === 'object' && error !== null && 'status' in error && error.status === status;

// Accepts any thrown or returned error; server payloads vary, so the known shapes are probed.
export const getErrorMessage = (rawError: unknown): string => {
  const error = rawError as ApiError | undefined;

  if (error?.data?.message) {
    if (Array.isArray(error.data.message)) {
      return error.data.message.join('. ');
    } else {
      return error.data.message;
    }
  } else if (error?.data?.detail) {
    if (Array.isArray(error?.data?.detail)) {
      if (Array.isArray(error.data.detail[0].msg)) {
        return error.data.detail[0].msg[0].msg;
      } else {
        return error.data.detail[0].msg;
      }
    } else {
      return error.data.detail?.msg;
    }
  } else if (error?.message) {
    return error.message;
  } else if (error?.error) {
    return error.error;
  } else {
    return 'Server unavailable';
  }
};
